import * as THREE from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import "./SCSS/index.scss";

class RTTScene {
  constructor({ onLoadRoom = undefined }) {
    this.sizes = undefined;
    this.scene = undefined;
    this.renderTarget = undefined;
    // this.ambientLight = undefined;
    // this.pointLight = undefined;
    this.camera = undefined;
    // this.cubeGeometry = undefined;
    // this.bakedGeometry = undefined;
    this.roomMesh = undefined;
    this.onLoadRoom = onLoadRoom;
    this.textureLoader = new THREE.TextureLoader();
    this.dracoLoader = new DRACOLoader();
    this.dracoLoader.setDecoderPath("/draco/");
    this.gltfLoader = new GLTFLoader();
    this.gltfLoader.setDRACOLoader(this.dracoLoader);
    this.material = undefined;
    this.clock = undefined;
    this.rafID = undefined;
  }

  setScene() {
    this.sizes = {
      width: window.innerHeight,
      height: window.innerHeight,
    };

    window.addEventListener("resize", () => {
      this.sizes.width = window.innerHeight;
      this.sizes.height = window.innerHeight;

      this.camera.aspect = this.sizes.width / this.sizes.height;
      this.camera.updateProjectionMatrix();
    });

    this.renderTarget = new THREE.WebGLRenderTarget(
      this.sizes.width,
      this.sizes.height
    );

    this.scene = new THREE.Scene();
    this.scene.background = new THREE.Color("#f6e9ff");
    this.camera = new THREE.PerspectiveCamera(
      75,
      this.sizes.width / this.sizes.height,
      0.1,
      100
    );

    this.camera.position.set(0, 0, 1);
    this.scene.add(this.camera);

    this.gltfLoader.load(
      "models/baked/baked.glb",
      (gltf) => {
        const bakedTexture = this.textureLoader.load("textures/baked.jpeg");
        bakedTexture.flipY = false;
        bakedTexture.encoding = THREE.sRGBEncoding;

        const bakedMaterial = new THREE.MeshBasicMaterial({
          map: bakedTexture,
          //wireframe: true,
        });
        gltf.scene.rotation.set(0, -Math.PI * 0.25, 0);
        gltf.scene.position.set(0, 0, -3);
        gltf.scene.traverse((children) => {
          if (children.type === "Mesh") {
            children.material = bakedMaterial;
          }
        });
        this.roomMesh = gltf.scene;
        this.scene.add(this.roomMesh);

        if (typeof this.onLoadRoom === "function") {
          this.onLoadRoom();
        }
      },
      (progress) => {},
      (error) => {
        console.log(error);
      }
    );

    // this.cubeGeometry = new THREE.BoxGeometry(0.5, 0.5, 0.5);
    // this.material = new THREE.MeshPhongMaterial({ color: "#0000ff" });
    // this.cube = new THREE.Mesh(this.cubeGeometry, this.material);
    // this.scene.add(this.cube);

    // this.ambientLight = new THREE.AmbientLight(new THREE.Color("#ffffff"), 0.5);
    // this.scene.add(this.ambientLight);

    // this.pointLight = new THREE.PointLight();
    // this.pointLight.position.set(1, 1, 1);
    // this.scene.add(this.pointLight);

    this.clock = new THREE.Clock();
  }

  play() {
    if (this.rafID) {
      return;
    }
    this.tick();
  }

  updateCamPosition(cameraRef) {
    const refCameraPosition = new THREE.Vector3();
    refCameraPosition.copy(cameraRef.position);
    //refCameraPosition.x = -1 * refCameraPosition.x;
    this.camera.position.copy(refCameraPosition);
    this.camera.rotation.copy(cameraRef.rotation);
  }

  tick() {
    const elapsedTime = this.clock.getElapsedTime();

    // this.cube.rotation.set(
    //   Math.sin(elapsedTime * 0.5),
    //   Math.cos(elapsedTime * 0.2),
    //   Math.sin(elapsedTime * 0.3)
    // );

    this.rafID = requestAnimationFrame(this.tick.bind(this));
  }
}

export default RTTScene;
